import * as semver from 'semver'
import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core'
import { ReleaseNotesService } from '../services/releaseNotes.service'

@Component({
  selector: 'new-badge',
  template: 'New',
  styleUrls: ['./newBadge.component.scss'],
  host: {
    '[class.badge]': 'true',
    '[class.badge-outline-success]': 'true',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewBadgeComponent {
  @Input() version: string

  constructor (
    private element: ElementRef<HTMLElement>,
    private releaseNotes: ReleaseNotesService,
  ) { }

  async ngOnInit () {
    if (!this.releaseNotes.previousRelease || Date.now() - this.releaseNotes.lastUpgradeTime > 7 * 24 * 3600 * 1000) {
      this.destroy()
      return
    }
    const version = semver.coerce(this.version)!.format()
    if (semver.lt(version, this.releaseNotes.previousRelease)) {
      this.destroy()
    }
  }

  private destroy () {
    this.element.nativeElement.remove()
  }
}
